import React from 'react';
import { KompisTooltip } from '@inter-ikea-kompis/react-components';
import { PopoverDirectionEnum } from '@inter-ikea-kompis/component-popover';
import { PopoverAlignmentEnum } from '@inter-ikea-kompis/component-popover';
import { e2e } from 'utils/queryUtils';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

type Props = {
  text: string;
  uniqueId: string;
  children: React.ReactNode;
  disabled?: boolean;
};

const KompisToolTip = ({ text, uniqueId, children, disabled }: Props) => {
  return e2e() || disabled ? (
    <>{children}</>
  ) : (
    <KompisTooltip
      text={text}
      uniqueId={uniqueId}
      theme={SkapaTheme}
      direction={PopoverDirectionEnum.top}
      alignment={PopoverAlignmentEnum.center}
      zIndex={1000000}
    >
      {children}
    </KompisTooltip>
  );
};

export default KompisToolTip;
